import type { TownsquareGoalUpdate } from '../../types';

export const isTownsquareGoalUpdate = (entity: any): entity is TownsquareGoalUpdate =>
	entity.__typename === 'TownsquareGoalUpdate';

export const getTownsquareGoalUpdateLink = (update: TownsquareGoalUpdate): string | null =>
	update?.url ?? null;
